/**
 * External dependencies
 */
import { size } from "lodash";
import { connect } from "react-redux";
import { Box } from "@towersystems/towersystems-design-system";

/**
 * Internal dependencies
 */
import NavList from "components/nav-list";
import libraryReports from "lib/report-library";
import { getReports } from "state/reports/selectors";

/**
 * Style dependencies
 */
import "./styles.scss";

const Navigation = ({ selected, myReportCount, reportLibraryCount }) => {
  return (
    <Box>
      <NavList>
        <NavList.NavListItem
          path="/reports/my-reports"
          label="My Views"
          active={selected === "my-reports"}
          suffix={myReportCount}
        ></NavList.NavListItem>
        <NavList.NavListItem
          path="/reports/report-library"
          active={selected === "report-library"}
          label="View Library"
          suffix={reportLibraryCount}
        ></NavList.NavListItem>
      </NavList>
    </Box>
  );
};

export default connect((state) => ({
  myReportCount: size(getReports(state)),
  reportLibraryCount: size(libraryReports),
}))(Navigation);
